import React from "react";
import { Container, Box, Typography } from "@mui/material";
import styled from "styled-components";

const SuccessMessage = styled(Typography)`
  font-size: 1.5rem;
  font-weight: 600;

  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
`;

const SubmissionSuccess = () => {
  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <SuccessMessage>
          Thank you for your submission!<br/> Your answers have been received.
        </SuccessMessage>
      </Box>
    </Container>
  );
};

export default SubmissionSuccess;
